<template>
  <div class="slds-notify_container">
    <div v-for="(toast,index) in toasts" 
         v-bind:class="setToastType(toast.type)" 
         :key="index" 
         class="slds-notify slds-notify_toast" 
         role="status">
      <span class="slds-assistive-text">{{toast.type}}</span>
      <span class="slds-icon_container slds-m-right_small slds-no-flex slds-align-top" v-bind:class="`slds-icon-utility-${toast.type}`" title="Description of icon when needed">
        <svg class="slds-icon slds-icon_small" aria-hidden="true">
          <use :xlink:href="`${iconPath}#${toast.type}`" />
        </svg>
      </span>
      <div class="slds-notify__content">
        <h2 v-html="toast.message" class="slds-text-heading_small"></h2>
      </div>
      <div class="slds-notify__close">
        <button v-on:click="removeToast(index)" class="slds-button slds-button_icon slds-button_icon-inverse" title="Close">
          <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
            <use :xlink:href="`${iconPath}#close`" />
          </svg>
          <span class="slds-assistive-text">Close</span>
        </button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name : 'Toast',
  data() {
    return {
      iconPath:
        "/libs/vendors/salesforce-lightning-design-system-2.6.2/assets/icons/utility-sprite/svg/symbols.svg"
    };
  },
  props: {
     toasts: {
        type: Array
    },
  },
  methods: {
    removeToast(index) {
      // eslint-disable-next-line vue/no-mutating-props
      this.toasts.splice(index, 1);
    },
    setToastType: function(toastType) {
      let toastStyle = "";
      switch (toastType) {
        case "success":
          toastStyle = "slds-theme_success";
          break;
        case "error":
          toastStyle = "slds-theme_error";
          break;
        case "warning":
          toastStyle = "slds-theme_warning";
          break;
        default:
          "slds-theme_info";
      }
      return toastStyle;
    }
  }
};
</script>

<style>
.slds-notify_container {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  z-index: 10;
  transform: translate(-50%, 0);
  max-width: 600px;
}
</style>